module.exports = __webpack_public_path__ + "static/img/firstpageProduct-new.4b29b93.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/firstpageProduct-new.webp
// module id = +0HB
// module chunks = 0